export const configData = {
  footerSupportNumber: '02128111288',
  // footerSupportNumber: '02191346283',
  footerZibalNumber: '+982191344112',
  footerZibalNumberShow: '۰۲۱ - ۹۱ ۳۴ ۴۱ ۱۲',
  footerSupportNumberShow: '۰۲۱ - ۲۸ ۱۱ ۱۲ ۸۸',
  // footerSupportNumberShow: '۰۲۱ - ۹۱ ۳۴ ۶۲ ۸۳',
  footerAddress: 'تهران، خیابان شریعتی، کوچه پروین، پلاک ۱۸، واحد ۶',
}
